import { render, staticRenderFns } from "./Openhouse.vue?vue&type=template&id=48810a28"
import script from "./Openhouse.vue?vue&type=script&lang=js"
export * from "./Openhouse.vue?vue&type=script&lang=js"
import style0 from "./Openhouse.vue?vue&type=style&index=0&id=48810a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports